<white-card *ngIf="modes$ | async as modes">
  <page-header-actions>
    <page-title labelKey="TASKS.LABEL"></page-title>
    <ng-container buttons>
      <button
        *ngIf="canSendToPse()"
        mat-flat-button
        color="primary"
        [disabled]="modes.tasksListMode !== TASK_SEARCH_MODE.ARCHIVED || !modes.isOnline"
        (click)="sendToPse()"
      >
        <mat-icon>send</mat-icon>
        {{ 'TASKS.PSE_SEND.BUTTON' | translate }}
      </button>
      <button *ngIf="canViewCurrent()" mat-flat-button color="primary" (click)="goToTasksMap()">
        <mat-icon>map</mat-icon>
        {{ 'MAP' | translate }}
      </button>
      <button buttons mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="syncAll()"  *ngIf="modes.isOnline && (modes.tasksListMode === TASK_SEARCH_MODE.ACTIVE || modes.tasksListMode === TASK_SEARCH_MODE.MY) && canSynchronizeAll() && (connectionStatusService.networkStatus$ | async)">
          <mat-icon class="material-icons-outlined" fontIcon="sync"></mat-icon>
          {{ 'TASKS.SYNC_ALL' | translate }}
        </button>
        <button  *ngIf="canViewCurrent()" mat-menu-item (click)="goToTasksMap()">
          <mat-icon class="material-icons-outlined" fontIcon="map"></mat-icon>
          {{ 'MAP' | translate }}
        </button>
        <button mat-menu-item (click)="resetGrid()">
          <mat-icon class="material-icons-outlined" fontIcon="filter_alt_off"></mat-icon>
          {{ 'CLEAR_FILTERS' | translate }}
        </button>
        <button mat-menu-item (click)="addFilter()">
          <mat-icon class="material-icons-outlined" fontIcon="library_add"></mat-icon>
          {{ 'ADD_FILTER' | translate }}
        </button>
        <button *ngIf="modes.isOnline && modes.tasksListMode === TASK_SEARCH_MODE.ACTIVE && canReceive()" mat-menu-item (click)="assignToMe()" [disabled]="grid.selectedRows.length === 0">
          <mat-icon class="material-icons-outlined" fontIcon="bookmark_add"></mat-icon>
          {{ 'TASKS.ASSIGN' | translate }}
        </button>
        <button *ngIf="modes.isOnline && (modes.tasksListMode === TASK_SEARCH_MODE.ACTIVE || modes.tasksListMode === TASK_SEARCH_MODE.MY)" mat-menu-item (click)="unassignFromMe()" [disabled]="grid.selectedRows.length === 0">
          <mat-icon class="material-icons-outlined" fontIcon="bookmark_remove"></mat-icon>
          {{ 'TASKS.UNASSIGN' | translate }}
        </button>
        <button *ngIf="modes.tasksListMode === TASK_SEARCH_MODE.ARCHIVED && canAcceptTasks()" mat-menu-item (click)="moveToAccept()" [disabled]="grid.selectedRows.length === 0">
          <mat-icon class="material-icons-outlined" fontIcon="published_with_changes"></mat-icon>
          {{ 'TASKS.MOVE_TO_ACCEPT' | translate }}
        </button>
        <button *ngIf="modes.tasksListMode === TASK_SEARCH_MODE.TO_ACCEPT && canEditTasks()" mat-menu-item (click)="moveToInProgress()" [disabled]="grid.selectedRows.length === 0">
          <mat-icon class="material-icons-outlined" fontIcon="published_with_changes"></mat-icon>
          {{ 'TASKS.MOVE_TO_IN_PROGRESS' | translate }}
        </button>
        <button *ngIf="modes.tasksListMode === TASK_SEARCH_MODE.TO_ACCEPT && canMultiAccept()" mat-menu-item (click)="multiAccept()" [disabled]="grid.selectedRows.length === 0">
          <mat-icon class="material-icons-outlined" fontIcon="done_all"></mat-icon>
          {{ 'TASKS.MULTI_APPROVE' | translate }}
        </button>
        <button mat-menu-item (click)="grid.exportXLS()">
          <mat-icon class="material-icons-outlined" fontIcon="get_app"></mat-icon>
          {{ 'EXPORT_XLS' | translate }}
        </button>
        <button
          *ngIf="connectionStatusService.networkStatus$ | async"
          mat-menu-item
          (click)="updateOfflineCache()"
        >
          <mat-icon>download</mat-icon>
          {{ 'TASKS.UPDATE_OFFLINE_CACHE' | translate }}
        </button>
      </mat-menu>
    </ng-container>

  </page-header-actions>
  <div class="toggle-wrapper">
    <mat-button-toggle-group [(value)]="modes.tasksListMode" (change)="changeMode($event)">
      <mat-button-toggle *ngIf="canReceive()" [value]="TASK_SEARCH_MODE.MY">{{ TASK_SEARCH_MODE.MY | translate }}</mat-button-toggle>
      <mat-button-toggle *ngIf="modes.isOnline && canViewCurrent()" [value]="TASK_SEARCH_MODE.ACTIVE">{{ TASK_SEARCH_MODE.ACTIVE | translate }}</mat-button-toggle>
      <mat-button-toggle *ngIf="modes.isOnline && canViewToAccept()" [value]="TASK_SEARCH_MODE.TO_ACCEPT">{{ TASK_SEARCH_MODE.TO_ACCEPT | translate }}</mat-button-toggle>
      <mat-button-toggle *ngIf="modes.isOnline" [value]="TASK_SEARCH_MODE.ARCHIVED">{{ TASK_SEARCH_MODE.ARCHIVED | translate }}</mat-button-toggle>
    </mat-button-toggle-group>
    <custom-filter
      [filterModel]="store.tasksGridSelectedFilter"
      [filters]="store.tasksGridFilters"
      (filterChange)="store.handleTasksGridFilterChange($event)"
      (deleteFilter)="deleteFilter()"
      (updateFilter)="updateFilter()"
      (addFilter)="addFilter()"
      (restoreFilter)="restoreFilter()"
    ></custom-filter>
  </div>
  <grid-master
    #grid
    [context]="{tasksListMode: modes.tasksListMode}"
    [rowData]="tasks$ | async"
    [columnDefs]="columnDefs"
    [headersKey]="'TASKS_GRID'"
    [sizeColumnsToFit]="false"
    (cellClickedEvent)="rowClicked($event)"
    [rowHover]="true"
    [rowClassRules]="rowClassRules"
    [isRowSelectable]="isRowSelectable"
  >
  </grid-master>

</white-card>
